<!-- @format -->

<template>
    <div class="gst-hero-wrapper">
        <section class="gst-hero">
            <video
                poster="/assets/hero_video_frame_1.png"
                class="video"
                autoplay
                muted
                loop
                playsinline>
                <source
                    v-if="video.mp4"
                    :src="video.mp4"
                    type="video/mp4" />
                <source
                    v-if="video.ogv"
                    :src="video.ogv"
                    type="video/ogv" />
                <source
                    v-if="video.webm"
                    :src="video.webm"
                    type="video/webm" />
                Your browser doesn't support HTML5 video.
            </video>
            <div class="gst-hero__content d-flex">
                <div class="gst-default-content">
                    <h1>{{ titleText }}</h1>
                    <h3>{{ subtitleText }}</h3>
                </div>
                <div class="search-container">
                    <SearchProductsVue :location-to-prepopulate="locationToPrepopulate" />
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import SearchProductsVue from './SearchProducts.vue';

export default {
    name: 'TheHero',
    components: {
        SearchProductsVue,
    },
    i18nOptions: {
        namespaces: 'main',
    },
    props: {
        title: {
            type: String,
            default: null,
        },
        subtitle: {
            type: String,
            default: null,
        },
        video: {
            type: Object,
            default: () => ({}),
        },
        locationToPrepopulate: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        titleText() {
            return this.title || this.$t('views.home.theHome.title');
        },
        subtitleText() {
            return this.subtitle || this.$t('views.home.theHome.subtitle');
        },
    },
};
</script>
